<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="57rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{ popTitle }}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>
      <!--content-->
      <v-card-text>
        <div class="dropdown-group ty01">
          <v-list v-model:opened="listOpen">
            <!--depth1 -->
            <v-list-group v-for="(itemD1, seqD1) in filterArray(0)" :key="itemD1.idx" :value="itemD1.idx">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" :title="itemD1.treeName" :class="{'on': itemD1.selected, 'hidden-icon': filterArray(itemD1.idx).length === 0}">
                  <div class="check-group">
                    <v-checkbox
                      :model-value="false"
                      @click.stop="onCheckItem(itemD1)"
                    ></v-checkbox>
                  </div>
                </v-list-item>
              </template>
              <!--depth2 -->
              <v-list-group v-for="(itemD2, seqD2) in filterArray(itemD1.idx)" :key="itemD2.idx" :value="itemD2.idx">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" :title="itemD2.treeName" :class="{'on': itemD2.selected, 'hidden-icon': filterArray(itemD2.idx).length === 0}">
                    <div class="check-group">
                      <v-checkbox
                        :model-value="false"
                        @click.stop="onCheckItem(itemD2)"
                      ></v-checkbox>
                    </div>
                  </v-list-item>
                </template>
                <!--depth3 -->
                <v-list-group v-for="(itemD3, seqD3) in filterArray(itemD2.idx)" :key="itemD3.idx" :value="itemD3.idx">
                  <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" :title="itemD3.treeName" :class="{'on': itemD3.selected, 'hidden-icon': filterArray(itemD3.idx).length === 0}">
                      <div class="check-group">
                        <v-checkbox
                          :model-value="false"
                          @click.stop="onCheckItem(itemD3)"
                        ></v-checkbox>
                      </div>
                    </v-list-item>
                  </template>
                  <!--depth4 필요하면 추가 -->
                  <v-list-group v-for="(itemD4, seqD4) in filterArray(itemD3.idx)" :key="itemD4.idx" :value="itemD4.idx">
                    <template v-slot:activator="{ props }">
                      <v-list-item v-bind="props" :title="itemD4.treeName" :class="{'on': itemD4.selected, 'hidden-icon': filterArray(itemD4.idx).length === 0}">
                        <div class="check-group">
                          <v-checkbox
                            :model-value="false"
                            @click.stop="onCheckItem(itemD4)"
                          ></v-checkbox>
                        </div>
                      </v-list-item>
                    </template>
                    <!--depth5 필요하면 추가 -->
                    <v-list-group v-for="(itemD5, seqD5) in filterArray(itemD4.idx)" :key="itemD5.idx" :value="itemD5.idx">
                      <template v-slot:activator="{ props }">
                        <v-list-item v-bind="props" :title="itemD5.treeName" :class="{'on': itemD5.selected, 'hidden-icon': filterArray(itemD5.idx).length === 0}">
                          <div class="check-group">
                            <v-checkbox
                              :model-value="false"
                              @click.stop="onCheckItem(itemD5)"
                            ></v-checkbox>
                          </div>
                        </v-list-item>
                      </template>
                      <!--depth6 필요하면 추가 -->
                      <v-list-group v-for="(itemD6, seqD6) in filterArray(itemD5.idx)" :key="itemD6.idx" :value="itemD6.idx">
                        <template v-slot:activator="{ props }">
                          <v-list-item v-bind="props" :title="itemD6.treeName" :class="{'on': itemD6.selected, 'hidden-icon': filterArray(itemD6.idx).length === 0}">
                            <div class="check-group">
                              <v-checkbox
                                :model-value="false"
                                @click.stop="onCheckItem(itemD6)"
                              ></v-checkbox>
                            </div>
                          </v-list-item>
                        </template>
                      </v-list-group>
                      <!--depth6 -->
                    </v-list-group>
                    <!--depth5 -->
                  </v-list-group>
                  <!--depth4 -->
                </v-list-group>
                <!--depth3 -->
              </v-list-group>
              <!--depth2 -->
            </v-list-group>
            <!--depth1 -->
          </v-list>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class=" d-flex justify-end"><!--pop-bottom-bg-->
        <c-btn01 v-bind="btnSave" @click.prevent.stop="handleForm"/>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue'
import CompanyService from "@/services/company.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps(['mode'])
const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//ui
const btnSave = computed(() =>({
  btnText: t('message.confirm'),
}))

//bind
const snackbar = ref(false)
const snackText = ref('')
const listOpen = ref([])
const items:any = ref([])
const popTitle = ref('')

//hook
onBeforeUpdate (()=>{
  items.value = []
})

onUpdated (() => {
  if (!storeRef.popupIdx.value)
    return;

  if (dialog.value) {
    let params = {idx: 0, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
    CompanyService.getCompanyTreeList(params).then(
      (response) => {
        items.value = response.result
        listOpen.value = getAllIdxs()
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

const filterArray = computed(()=>(param) => {return _.filter(items.value, {parentIdx: param}) })
const getAllIdxs = ()=> {return _.map(items.value, "idx")}

const onCheckItem=(item)=>{
  //싱글모드면 단일선택
  if(props.mode=='single')
    emit('confirm', [item])
  else
    item.selected = !item.selected
}

const clearAllSelected=(list)=> {
  list.forEach(item => {
    item.selected = false;
    if (item.children?.length) {
      clearAllSelected(item.children);
    }
  });
}

const handleForm=()=>{
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else {
    emit('confirm', _.filter(items.value, {selected: true}))
  }
}
</script>


<style lang="scss">

</style>
